import React from "react";
import styled from "styled-components";
import img1 from "../images/fmcg11.jpg";
import bkgroundimg from "../images/fmcgpicking1.jpg";

function Fmcg() {
  // Function to handle tab switching
  const openTab = (evt, cityName) => {
    // Get all elements with class="tabcontent" and hide them
    const tabcontent = document.getElementsByClassName("tabcontent");
    for (let i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }

    // Get all elements with class="tablinks" and remove the class "active"
    const tablinks = document.getElementsByClassName("tablinks");
    for (let i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(" active", "");
    }

    // Show the current tab and add an "active" class to the button
    document.getElementById(cityName).style.display = "block";
    evt.currentTarget.className += " active";
  };

  return (
    <FmcgCon>
      <div className="bkgpic_msg">
        <div className="message">
          <button>Contact Us</button>
        </div>
      </div>
      <a className="globalhome" href="/">
        Global Home{" "}
      </a>
      | FMCG
      <div className="imgandesc">
        <div className="desc-container">
          <div className="tab">
            <button
              className="tablinks"
              onClick={(e) => openTab(e, "Overview")}
            >
              Overview
            </button>
            <button
              className="tablinks"
              onClick={(e) => openTab(e, "Services")}
            >
              Services
            </button>
            <button
              className="tablinks"
              onClick={(e) => openTab(e, "ContactFMCG")}
            >
              Contact Us
            </button>
          </div>

          {/* Tab Content */}
          <div id="Overview" className="tabcontent">
            <h3>Overview</h3>
            <p>
              On-time delivery is everything in the FMCG business. In a world
              that is witnessing disruptions, raw material shortages, and
              increasing costs, it is critical for the FMCG supply chain to be
              efficient, resilient, and agile. Discover new paths with an
              integrated logistics solution that optimizes your FMCG supply
              chain while being mindful of the environment.
            </p>
            <br />

            <p>
              Fast moving consumer goods (FMCG) form one of the largest
              industries worldwide. From our morning showers with a jojoba
              shampoo to our oats and fruit breakfast, or office outings at a
              local pub or snacks at a street vendor – our worlds spin around
              consumer goods.
            </p>
            <br />

            <p>
              The industry today is constantly being disrupted by ever-changing
              consumer preferences and new technologies. Customers demand
              innovative products, which means producing a wider range of goods
              at higher volumes quickly. In developing markets, consumers are
              also spending more, which raises the call for an expanded supply
              chain.
            </p>
          </div>

          <div id="Services" className="tabcontent">
            <h3>Services</h3>
            <p>
              At Integral Freight, we help FMCG companies by providing seamless
              solutions, led by experts who understand the unique requirements
              and standards of the industry. We leverage this knowledge to build
              our supply chain solutions around customer needs, allowing us to
              serve some of the world´s most visible brands.
              <br />
              <br />
              <ul>
              <button><a href="/FoodCon">Food</a></button>

              </ul>
            </p>
          </div>

          <div id="ContactFMCG" className="tabcontent">
            <h3>Contact our FMCG industry experts</h3>
            <p>
              We are an experienced team of industry professionals and we will
              be your initial touch point, helping you find a solution that fits
              your needs. We’re only a click away!
            </p>
            <div className="ContSteps">
              <div>Enquiry</div>
              <div>Contact</div>
              <div>Finish</div>
            </div>
          </div>
        </div>

        <div className="image-container">
          <img className="image" src={img1} alt="FMCG service" />
        </div>
      </div>
    </FmcgCon>
  );
}

export default Fmcg;

const FmcgCon = styled.div`
  width: 75vw;
  margin-left: calc((100vw - 75vw) / 2);
  margin-right: calc((100vw - 75vw) / 2);

  .bkgpic_msg {
    background-image: url(${bkgroundimg});
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    height: 30vh;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }
  .tablinks {
    text-decoration: 2px underline;
    text-decoration-color: green;
    font-size: 18px;
  }


  .globalhome {
    padding-bottom: 20px;
  }

  .imgandesc {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    justify-content: center;
    margin-top: 50px;
    gap: 20px;
    width: 75%;
    margin-left: 220px;

  }

    .imgandesc .desc-container {
    width: 50vw;
    margin-left: -80px;
  }

  .image-container {
    width: 24vw;

      align: right;
  }

  .image-container .image {
    width: 24vw;
    height: 30vh;

  align: right;
  }

  .ContSteps {
    display: flex;
    justify-content: center;
    align-items: center;
  }


  .tab {
    overflow: hidden;
    border: 1px solid #ccc;
    background-color: #f1f1f1;
  }

  .tab button {
    background-color: inherit;
    float: left;
    border: none;
    outline: none;
    cursor: pointer;
    padding: 14px 16px;
    transition: 0.3s;
  }

}

/* Go from zero to full opacity */
@keyframes fadeEffect {
  from {opacity: 0;}
  to {opacity: 1;}
}


  .tab button:hover {
    background-color: #ddd;
  }

  .tab button.active {
    background-color: #ccc;
  }

  .tabcontent {
    display: none;
    padding: 6px 12px;
    border: 1px solid #ccc;
    border-top: none;
  }

  @media (max-width: 700px) {
    width: 100vw;

    .imgandesc {
      display: grid;
      grid-template-columns: repeat(1, 1fr);
      justify-content: center;
      margin-top: 50px;
      gap: 30px;
      margin-left: -85px;
      padding-left: 5px;
      padding-right: 15px;
    }

    .image-container .image {
      width: 100vw;
      height: 30vh;
      justify-content: center;
      align-items: center;
      border-radius: 0px 200px 200px 0px;
    }

    .desc-containe {
      width: 100%;
    }

    .bkgpic_msg {
      margin-left: -65px;
    }
  }
`;
